/**
 * 格式化工具函数（客服查询模块）
 */

export function vipGradeText(v) {
  return { 0: "非会员", 1: "普通会员", 2: "超级会员" }[v] || "未知";
}

export function rankText(v) {
  return { 0: "非会员", 1: "周/月", 2: "季", 4: "年", 8: "永久" }[v] || "未知";
}

export function formatTimestamp(ts) {
  if (!ts) return "-";
  const d = new Date(ts * 1000);
  return d.toLocaleDateString("zh-CN");
}

export function formatOptionalDateTime(value) {
  if (typeof value !== "string") return "";
  const text = value.trim();
  if (!text) return "";
  const time = Date.parse(text.replace(/-/g, "/"));
  return Number.isNaN(time) ? "" : text;
}

export function taskStatusText(s) {
  return (
    { "-1": "失败", 0: "已提交", 1: "处理中", 2: "成功" }[String(s)] || "未知"
  );
}

export function taskStatusClass(s) {
  return (
    { "-1": "tag-red", 0: "tag-gray", 1: "tag-blue", 2: "tag-green" }[
      String(s)
    ] || "tag-gray"
  );
}

export function viduStatusClass(state) {
  if (!state) return "tag-gray";
  const s = String(state).toLowerCase();
  if (s.includes("success") || s.includes("成功")) return "tag-green";
  if (s.includes("fail") || s.includes("失败")) return "tag-red";
  if (
    s.includes("process") ||
    s.includes("处理") ||
    s.includes("queue") ||
    s.includes("排队")
  )
    return "tag-blue";
  return "tag-gray";
}

export function lipSyncStatusText(s) {
  return (
    {
      "-1": "失败",
      0: "正在生成数字人",
      10: "正在制作视频",
      30: "成功",
      40: "参数异常",
      50: "服务异常",
    }[String(s)] || "未知"
  );
}

export function lipSyncStatusClass(s) {
  const m = {
    "-1": "tag-red",
    0: "tag-blue",
    10: "tag-blue",
    30: "tag-green",
    40: "tag-red",
    50: "tag-red",
  };
  return m[String(s)] || "tag-gray";
}
